module.exports = __webpack_public_path__ + "img/assess-main-upArrow.d9c0d4b2.svg";